// Used only by the disabled S2S dispatch in `event()` below — restore together.
// import analyticsApi from '@/src/api/rtkQuery/analyticsApi'
// import { store } from '@/src/redux/store'
// import { getuuid } from '@/src/utils/generalUtils/uuid'
import pushToNewRelic from '@/src/utils/analytics/newRelic/pushToNewRelic'
import { getMobileDeviceType } from '@/src/utils/deviceType'
import { logError } from '@/src/utils/logError'
import ClevertapReact from './clevertap'
import { ClevertapAndroid } from './clevertapAndroid'
import { ClevertapIos } from './clevertapIos'

const CLEVERTAP_KEY = process.env.NEXT_PUBLIC_CLEVERTAP_KEY || ''
class Clevertap {
    enabled: boolean
    constructor() {
        this.enabled = false
        if (CLEVERTAP_KEY) {
            this.enabled = true
            ClevertapReact.initialize(CLEVERTAP_KEY)
        }
    }

    event = (name: string, payload: any = {}) => {
        try {
            if (this.enabled) {
                setTimeout(() => {
                    const deviceType = getMobileDeviceType()
                    if (deviceType === 'AndroidApp') {
                        ClevertapAndroid.event(name, payload)
                    } else if (deviceType === 'iPhoneApp') {
                        ClevertapIos.event(name, payload)
                    } else {
                        ClevertapReact.event(name, payload)
                    }
                }, 300)
            }
            /*
             * Disabled: the S2S event POST to /flight/search/v2/logui. CleverTap and New Relic
             * still receive every event; only the server-to-server copy is off.
             *
             * const s2sPayload: any = {
             *     id: getuuid(),
             *     schemaName: `userEvents.${name.toLowerCase()}`,
             *     schemaVersion: '0.1',
             *     timestamp: new Date().getTime(),
             *     tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
             *     data: payload
             * }
             * store.dispatch(analyticsApi.endpoints.sendS2SEvent.initiate(s2sPayload))
             */
            pushToNewRelic(name, payload)
        } catch (e) {
            logError('CleveratapEvent', e)
        }
    }

    profile = (payload: any) => {
        if (this.enabled) {
            ClevertapReact.profile(payload)
        }
    }

    logout = () => {
        if (this.enabled) {
            ClevertapReact.logout()
        }
    }
}

const ClevertapObject = new Clevertap()
export default ClevertapObject
